/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Pin_TitleInputs */



/**
* | output |
* | --- |
* | "Pin" |
*
* @param {Voice_Manager_Pin_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pin_title = /** @type {((inputs?: Voice_Manager_Pin_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pin_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Epingler")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stift")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spillo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Приколоть")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alfiler")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("别针")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ピン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नत्थी करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alfinete")
	return /** @type {LocalizedString} */ ("Pin")
});